document.addEventListener("DOMContentLoaded", function() {
  
  let isProgrammaticChange = false;

  // Helium（React）の内部stateを強制的に更新して値を反映させるヘルパー関数
  function setHeliumInputValue(input, value) {
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    if (nativeInputValueSetter) {
      nativeInputValueSetter.call(input, value);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      input.value = value;
    }
  }

  function initHeliumZipInput(zipInput) {
    if (zipInput.hasAttribute('data-zip-initialized')) return;
    zipInput.setAttribute('data-zip-initialized', 'true');

    zipInput.setAttribute('maxlength', '7');
    let prevLength = zipInput.value.length;

    zipInput.addEventListener('keydown', () => {
      prevLength = zipInput.value.length;
    });

    zipInput.addEventListener('input', (e) => {
      if (isProgrammaticChange) return;

      const currentValue = e.target.value;
      const currentLength = currentValue.length;
      const cleanValue = currentValue.replace(/[^0-9]/g, '');

      prevLength = currentLength;
      removeErrorMessage(zipInput);

      if (cleanValue.length === 5 || cleanValue.length === 6 || cleanValue.length === 7) {
        const form = zipInput.closest('form');
        const elements = {
          zipInput: zipInput,
          provinceSelect: form.querySelector('select[name*="province"]') || form.querySelector('select[data-cf-column-key*="province"]'),
          cityInput: form.querySelector('input[name*="city"]') || form.querySelector('input[data-cf-column-key*="city"]'),
          address1Input: form.querySelector('input[name*="address1"]') || form.querySelector('input[data-cf-column-key*="address1"]')
        };
        fetchAddress(cleanValue, elements);
      } else {
        removeExistingPopup(zipInput);
      }
    });

    zipInput.addEventListener('change', () => {
      if (isProgrammaticChange) return;
      prevLength = zipInput.value.length;
    });
  }

  function checkAndApplyHeliumZip() {
    const zipInputs = document.querySelectorAll('input[name*="zip"], input[data-cf-column-key*="zip"], input[id^="AddressZip"]');
    zipInputs.forEach((input) => {
      initHeliumZipInput(input);
    });
  }

  checkAndApplyHeliumZip();

  // 住所検索・ポップアップ制御ロジック 
  async function fetchAddress(zip, elements) {
    const endpoint = `https://address-api.maruzenjunkudo.co.jp/api/v2/searchcode/${zip}`;
    try {
      removeExistingPopup(elements.zipInput);
      if (zip.length === 7) {
        removeErrorMessage(elements.zipInput);
      }

      const response = await fetch(endpoint, {
        method: 'GET'
      });

      if (!response.ok) {
        if (zip.length === 7) showErrorMessage(elements.zipInput);
        return;
      }

      const data = await response.json();
      
      if (data.count >= 1 && data.addresses && data.addresses.length > 0) {
        removeErrorMessage(elements.zipInput);
        if (zip.length === 5 || zip.length === 6 || zip.length === 7) {
          showAddressPopup(data, elements);
        }
      } 
      else {
        if (zip.length === 7) showErrorMessage(elements.zipInput);
      }
    } catch (error) {
      console.error("Address API Error:", error);
      if (zip.length === 7) showErrorMessage(elements.zipInput);
    }
  }

  function showAddressPopup(data, elements) {
    const addresses = data.addresses;
    const totalCount = data.count;

    removeExistingPopup(elements.zipInput);

    const container = document.createElement('div');
    container.className = 'address-candidate-popup';

    const header = document.createElement('div');
    header.className = 'popup-header';
    
    header.innerText = `該当する住所が ${addresses.length} 件あります（クリックして選択）`;
    container.appendChild(header);

    const ul = document.createElement('ul');

    addresses.forEach((addr, index) => {
      const li = document.createElement('li');
      if (index % 2 === 1) { li.classList.add('zebra-stripe'); }
      li.innerText = `${addr.pref_name || ''} ${addr.city_name || ''} ${addr.town_name || ''}`;

      li.addEventListener('click', () => {
        fillAddress(addresses[index], elements);
        container.remove();
      });
      ul.appendChild(li);
    });

    container.appendChild(ul);

    if (elements.zipInput && elements.zipInput.parentNode) {
      elements.zipInput.parentNode.insertBefore(container, elements.zipInput.nextSibling);
    }
  }

  function showErrorMessage(zipInput) {
    removeErrorMessage(zipInput);
    zipInput.classList.add('zip-input-error');

    const errorDiv = document.createElement('div');
    errorDiv.className = 'address-zip-error-msg';
    errorDiv.innerText = '郵便番号を正しく入力してください';

    if (zipInput && zipInput.parentNode) {
      zipInput.parentNode.insertBefore(errorDiv, zipInput.nextSibling);
    }
  }

  function removeErrorMessage(zipInput) {
    if (!zipInput) return;
    zipInput.classList.remove('zip-input-error');
    const form = zipInput.closest('form') || document;
    const existingError = form.querySelector('.address-zip-error-msg');
    if (existingError) existingError.remove();
  }

  function removeExistingPopup(zipInput) {
    if (!zipInput) return;
    const form = zipInput.closest('form') || document;
    const existing = form.querySelector('.address-candidate-popup');
    if (existing) existing.remove();
  }

  function fillAddress(addr, elements) {
    const { zipInput, provinceSelect, cityInput, address1Input } = elements;

    isProgrammaticChange = true;

    try {
      if (addr.zip_code && zipInput) {
        const formattedZip = addr.zip_code.replace(/[^0-9]/g, '');
        setHeliumInputValue(zipInput, formattedZip);
      }

      if (addr.pref_name && provinceSelect) {
        for (let i = 0; i < provinceSelect.options.length; i++) {
          if (provinceSelect.options[i].text.includes(addr.pref_name) || 
              provinceSelect.options[i].value.includes(addr.pref_name)) {
            provinceSelect.selectedIndex = i;
            provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }

      const cityName = addr.city_name || '';
      let townName = (addr.town_name && addr.town_name !== "以下に掲載がない場合") ? addr.town_name : "";

      let displayCity = cityName;
      let displayAddress = townName;

      const townMatch = townName.match(/^([^町\s]*町)(.+)$/);
      if (townMatch) {
        displayCity = cityName + townMatch[1];
        displayAddress = townMatch[2];
      }
      
      if (cityInput) {
        setHeliumInputValue(cityInput, displayCity);
      }
      
      if (address1Input) {
        setHeliumInputValue(address1Input, displayAddress);
      }
    } finally {
      setTimeout(() => {
        isProgrammaticChange = false;
      }, 50);
    }
  }

  const heliumObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        checkAndApplyHeliumZip();
      }
    });
  });

  heliumObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});